export default __webpack_public_path__ + "static/media/keto_weakness@2x.d00ba477.jpg";